/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@kubb/plugin-client/clients/fetch';
import type { GetSessionQueryResponse, GetSessionPathParams, GetSession401, GetSession403, GetSession404 } from '../types/GetSession.ts';
import type { Client, RequestConfig, ResponseErrorConfig } from '@kubb/plugin-client/clients/fetch';

function getGetSessionUrl(id: GetSessionPathParams['id']) {
  const res = { method: 'GET', url: `/sessions/${id}` as const };
  return res;
}

/**
 * @summary Get session by ID
 * {@link /sessions/:id}
 */
export async function getSession(id: GetSessionPathParams['id'], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<GetSessionQueryResponse, ResponseErrorConfig<GetSession401 | GetSession403 | GetSession404>, unknown>({
    method: 'GET',
    url: getGetSessionUrl(id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
